
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 153.9 153.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#405051","d":"M30.8 61.5h61.5V123H30.8V61.5z"}}),_c('path',{attrs:{"fill":"#23353B","d":"M61.6 61.5h30.8v30.8H61.6V61.5z"}}),_c('path',{attrs:{"fill":"#009DC8","d":"M92.3 61.5h30.8v30.8H92.3V61.5zM123.1 30.8h30.8v30.8h-30.8V30.8zM30.8 0h30.8v30.8H30.8V0z"}}),_c('path',{attrs:{"fill":"#50C6DF","d":"M92.3 0h30.8v61.5H92.3V0z"}}),_c('path',{attrs:{"fill":"#A36CAB","d":"M61.6 123.1h30.8v30.8H61.6v-30.8z"}}),_c('path',{attrs:{"fill":"#009DC8","d":"M61.6 30.8h30.8v30.8H61.6V30.8z"}}),_c('path',{attrs:{"fill":"#405051","d":"M0 123.1h30.8v30.8H0v-30.8z"}}),_c('path',{attrs:{"fill":"#091718","d":"M61.6 92.3h30.8v30.8H61.6V92.3z"}}),_c('path',{attrs:{"fill":"#E15A26","d":"M92.3 92.3h30.8v30.8H92.3V92.3z"}})])
          )
        }
      }
    